module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="content-header">\r\n    <h1>\r\n        <b>Core</b>invent\r\n    </h1>\r\n    <ol class="breadcrumb">\r\n        <!-- <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>\r\n    <li class="active">Dashboard</li> -->\r\n    </ol>\r\n</section>\r\n\r\n<section style="min-height: 750px;" class="content no-desktop">\r\n    <div class="row"></div>\r\n</section>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/dashboard/dashboardView.ejs
// module id = 416
// module chunks = 0